import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FavoriteIcon from '@mui/icons-material/Favorite';

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const toggleLang = () => {
    i18n.changeLanguage(i18n.language === 'ar' ? 'en' : 'ar');
  };

  // Hide full nav on the choice page — only show lang toggle
  const isChoice = location.pathname === '/';

  return (
    <AppBar position="sticky" elevation={0} sx={{ bgcolor: 'background.paper', borderBottom: '1px solid', borderColor: 'divider' }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ gap: 2, minHeight: 64 }}>
          {/* Logo */}
          <Box component={Link} to="/" sx={{ display: 'flex', alignItems: 'center', gap: 1, textDecoration: 'none', color: 'primary.main', flexGrow: isChoice ? 1 : 0 }}>
            <FavoriteIcon sx={{ fontSize: 28 }} />
            <Typography variant="h6" fontWeight={700} color="primary.main">
              بنك الدم
            </Typography>
          </Box>

          {!isChoice && (
            <Box sx={{ display: 'flex', gap: 1, flexGrow: 1, justifyContent: 'flex-end', alignItems: 'center' }}>
              <Button component={Link} to="/register" color="primary" variant={location.pathname === '/register' ? 'contained' : 'text'}>
                {t('nav.register')}
              </Button>
              <Button component={Link} to="/search" color="primary" variant={location.pathname === '/search' ? 'contained' : 'text'}>
                {t('nav.search')}
              </Button>
            </Box>
          )}

          <Button onClick={toggleLang} variant="outlined" size="small" sx={{ minWidth: 80 }}>
            {t('common.lang_toggle')}
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
